import React, { ReactElement } from 'react'

import Pad from '../../comps/Pad'
import PageReport from '../../comps/PageReport'

//@ts-ignore
import styles from './VideoReport.module.css'

export interface ImageReportProps {
  company: string
  image: string
  isPDF: boolean
  title: string
}

export default React.memo<ImageReportProps>(function ImageReport({
  company,
  image,
  isPDF,
  title,
}) {
  const picture = React.useMemo((): ReactElement => {
    return (
      <div className={styles['container']}>
        {' '}
        <Pad amt={20} />
        <video className={styles['video']} controls src={image} />
      </div>
    )
  }, [image])

  return (
    <PageReport
      company={company}
      companyBorder={true}
      isPDF={isPDF}
      title={title}
    >
      {picture}
    </PageReport>
  )
})
